document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('header-drawer a[href*="#"]').forEach(function (link) {
    link.addEventListener('click', function () {
      var drawer = document.querySelector('header-drawer');
      if (drawer) {
        var closeBtn = drawer.querySelector('.header__icon--menu, [data-close-drawer]');
        if (closeBtn) closeBtn.click();
      }
    });
  });
});